import React, {useEffect, useState} from 'react'
import {getAd} from "./service";

const AdBanner = (props) => {
    const { width, height } = props;

    const [ad, serAd] = useState();

    useEffect(() => {
        (async () => {
            const { data } = await getAd();
            serAd(data);
        })();
    },[]);

    return (
        <img
            src={ad && ad.photo_link}
            style={{cursor: 'pointer', width, height }}
            onClick={() => {
                window.location.href = ad.link;
            }}
        />
    )
};

export default AdBanner
